import img1 from '../images/1.jpg';
import img2 from '../images/2.jpg';
import img3 from '../images/3.jpg';
import img4 from '../images/4.jpg';
import img5 from '../images/5.jpg';
import img6 from '../images/6.jpg';
import img7 from '../images/7.jpg';
import img8 from '../images/8.jpg';

const cardsdata = [
  { image: img1, title: 'Womens Day' },
  { image: img2, title: 'The Perfect Match' },
  { image: img3, title: 'The Dog Woof' },
  { image: img4, title: 'The Easy Reach' },
  { image: img5, title: 'The Cooking' },
  { image: img6, title: 'The Hikaru' },
  { image: img7, title: 'Life Quotes' },
  { image: img8, title: 'The Beachball' },
  { image: img5, title: 'The Dog Woof' },
  { image: img1, title: 'The Easy Reach' },
  { image: img4, title: 'The Cooking' },
  { image: img2, title: 'The Hikaru' },
];

export default cardsdata;
